export default {
    blocked_title: 'Studio Access Paused',
    // Split around the clickable Skills link — only the host text links out.
    blocked_message_prefix: "You're behind on your microlearning. Complete your modules at ",
    blocked_message_suffix: ' to restore access.',
    incomplete_title: 'Modules to complete',
    show_more: 'Show {count} more',
    cta: 'Go to Skills to complete',
    restore_hint: 'Access restores automatically once your modules are complete.',
}
